import Visual1 from "../../img/screenshots/journals/journals-01.png";
import Visual2 from "../../img/screenshots/journals/journals-02.png";
import Visual3 from "../../img/screenshots/journals/journals-03.png";

export const TravelJournalFeatureContent = [
  {
    title: "Relive your travel experience",
    subtitle: "Document your travels",
    text: "Bring your adventures back to life! For each destination, write personal notes about your favourite moments, hidden gems, and must-see spots. Share with your travel community to relive those magical experiences and inspire others along the way.",
    image: Visual1,
  },
  {
    title: "Go down memory lane and upload your best travel photos",
    subtitle: "Upload travel photos",
    text: "Nothing tells a story like your photos. Add your favourite travel snapshots to your journals, transforming them into dynamic memories. Relive the sights, colours, and moments that made your trip unforgettable—and make your journals just as vivid.",
    image: Visual2,
  },
  {
    title: "Press the publish button and share your travel experience",
    subtitle: "Share journals with the community",
    text: `Hit publish and let your adventures inspire others! Don’t keep those amazing travel stories to yourself—share them with your followers. Your journals are packed with experiences, tips, and hidden gems that deserve to be seen. Ready? Publish and watch your travels come to life for everyone to enjoy!`,
    image: Visual3,
  },
];
